import { render, staticRenderFns } from "./BuildingServices.vue?vue&type=template&id=2d2a7140&"
import script from "./BuildingServices.vue?vue&type=script&lang=js&"
export * from "./BuildingServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports